import React from "react";
import clsx from "clsx";

import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import CloseIcon from "@material-ui/icons/Close";

import { APPS, FacilityData } from "../constants";

import useStyles from "./styles";

interface Props {
  selectedFacility: string;
  facilityData: FacilityData;
  currentActiveApp: APPS;
  onCloseClick: (event) => void;
  onApplicationClick?: (appName: APPS, isSaveButtonClicked?: boolean) => void;
  isManagementMode?: boolean;
  disabled?: boolean;
}

const ManagementHeader = React.memo((props: Props) => {
  const {
    selectedFacility,
    facilityData,
    currentActiveApp,
    onCloseClick,
    onApplicationClick,
    disabled = false,
    isManagementMode
  } = props;

  const classes = useStyles();

  const handleClickApplicationButton = (applicationName: APPS) => {
    onApplicationClick && onApplicationClick(applicationName);
  };

  const handleCloseButtonClick = event => {
    onCloseClick(event);
  };

  return (
    <div className={classes.managementContentHeader}>
      <div
        className={clsx(classes.managementHeader, {
          [classes.headerDisabled]: disabled
        })}
      >
        <div className={classes.managementHeaderPart}>
          <div
            className={clsx(classes.selectTrackButton, {
              [classes.selectedBlack]:
                currentActiveApp === APPS.FacilitySelector
            })}
            onClick={() => handleClickApplicationButton(APPS.FacilitySelector)}
          >
            Select Track
          </div>
          {selectedFacility && (
            <>
              <ArrowForwardIosIcon className={classes.rightArrow} />
              <div
                className={clsx(
                  classes.selectedFacilityName,
                  {
                    [classes.selectedGreen]:
                      currentActiveApp === APPS.ApplicationSelector
                  },
                  classes.capitalize
                )}
                onClick={() =>
                  handleClickApplicationButton(APPS.ApplicationSelector)
                }
              >
                {facilityData[selectedFacility].name.toLowerCase()}
              </div>
            </>
          )}
          {selectedFacility &&
            [APPS.TrackConditions, APPS.WorkoutScheduling].includes(
              currentActiveApp
            ) && (
              <>
                <ArrowForwardIosIcon className={classes.rightArrow} />
                <div
                  className={clsx(
                    classes.selectedAppName,
                    classes.selectedGreen
                  )}
                >
                  {currentActiveApp.split(/(?=[A-Z])/).join(" ")}
                </div>
              </>
            )}
        </div>

        {!isManagementMode && (
          <div
            className={classes.managementHeaderPart}
            onClick={handleCloseButtonClick}
          >
            <CloseIcon className={classes.closeIcon} />
          </div>
        )}
      </div>
    </div>
  );
});

export default ManagementHeader;
